module.exports = __webpack_public_path__ + "57b7d92f3dc9571b0366de52d868e97a.png";